<template>
  <div>
    <h1 class="title">Sales Point</h1>

    <section class="content">
      <form v-on:submit="formSubmit">
        <fieldset :disabled="$ajax.anyLoading">
          <div class="columns is-multiline">
            <div class="column is-one-quarter">
              <ServiceTipologyDD
                v-model="salesPoint.tipologyId"
                expanded
              ></ServiceTipologyDD>
            </div>

            <div class="column is-one-quarter">
              <b-field label="Ragione Sociale">
                <b-input
                  v-model.trim="salesPoint.name"
                  v_uppercase="salesPoint.name"
                  required
                ></b-input>
              </b-field>
            </div>
            <div
              class="column is-one-quarter"
              v-if="salesPoint.tipologyId === 2"
            >
              <b-field label="Insegna">
                <b-input
                  v-model.trim="salesPoint.ensign"
                  v_uppercase="salesPoint.ensign"
                  required
                ></b-input>
              </b-field>
            </div>

            <div
              class="column is-one-quarter"
              v-if="salesPoint.tipologyId === 2"
            >
              <b-field label="P.IVA">
                <b-input
                  v-model.trim="salesPoint.vatNumber"
                  v-on:input="typingVatNumber"
                ></b-input>
              </b-field>
              <div
                v-if="similar_var_numbers.length"
                style="font-size: 0.7em; text-align: left"
              >
                <div>
                  Sono presenti sales points con questa p.iva. Contatta
                  l'amministrazione per informazioni.
                  <ul>
                    <li
                      v-for="(sp, i) in similar_var_numbers"
                      v-bind:key="`sp_${sp.id}_${i}`"
                    >
                      {{ sp.name }} [{{ sp.ensign }}]
                      <code>{{ sp.vatNumber }}</code>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="column is-one-quarter">
              <SingleRegionDD :object="salesPoint"></SingleRegionDD>
            </div>
            <div class="column is-one-quarter">
              <b-field label="Provincia">
                <b-input
                  v-model.trim="salesPoint.province"
                  v_uppercase="salesPoint.province"
                  maxlength="2"
                  required
                ></b-input>
              </b-field>
            </div>
            <div class="column is-one-quarter">
              <b-field label="Città">
                <b-input
                  v-model.trim="salesPoint.city"
                  v_uppercase="salesPoint.city"
                  required
                ></b-input>
              </b-field>
            </div>

            <div class="column is-one-quarter">
              <b-field label="CAP">
                <b-input
                  v-model.trim="salesPoint.zipCode"
                  maxlength="5"
                  required
                ></b-input>
              </b-field>
            </div>
            <div class="column is-one-quarter">
              <b-field label="Indirizzo">
                <b-input
                  v-model="salesPoint.address"
                  v_uppercase="salesPoint.address"
                  required
                ></b-input>
              </b-field>
            </div>
            <div class="column is-one-quarter">
              <b-field label="Contatto telefonico">
                <b-input v-model.trim="salesPoint.phone"></b-input>
              </b-field>
            </div>

            <div
              class="column is-one-quarter"
              v-if="salesPoint.tipologyId === 2"
            >
              <b-field label="Referente">
                <b-input
                  v-model.trim="salesPoint.referent"
                  v_uppercase="salesPoint.referent"
                  required
                ></b-input>
              </b-field>
            </div>
            <div
              class="column is-one-quarter"
              v-if="salesPoint.tipologyId === 2"
            >
              <b-field label="Ruolo">
                <b-input
                  v-model.trim="salesPoint.role"
                  v_uppercase="salesPoint.role"
                  required
                ></b-input>
              </b-field>
            </div>
            <div
              class="column is-one-quarter"
              v-if="salesPoint.tipologyId === 2"
            >
              <b-field label="Grossista preferenziale">
                <b-input
                  v-model="salesPoint.primaryWholesaler"
                  v_uppercase="salesPoint.primaryWholesaler"
                  required
                ></b-input>
              </b-field>
            </div>


            <div
              class="column is-one-quarter"
            >
              <b-field label="Business Type">

                <b-select placeholder="Business Type" required v-model='salesPoint.businessType'>
                    <!--<option value></option>-->
                    <option v-for='(v,k) in businessTypes' :value="v" v-bind:key='k'>{{ v.toUpperCase()  }}</option>
                </b-select>

              </b-field>
            </div>
          </div>

          <section class="content">
            <div class="buttons is-right">
              <a
                class="button is-danger"
                :disabled="$ajax.anyLoading"
                v-if="salesPoint.id && $ajax.getUserRole().salePointDelete"
                v-on:click="onDelete"
              >
                <span class="icon is-small">
                  <i class="fas fa-trash"></i>
                </span>
                <span>Elimina Sales Point</span>
              </a>

              <button
                type="submit"
                class="button is-success"
                :disabled="$ajax.anyLoading"
              >
                <span class="icon is-small">
                  <i class="fas fa-check"></i>
                </span>
                <span>Salva Sales Point</span>
              </button>
            </div>
          </section>
        </fieldset>
      </form>
      <!--<pre class="has-text-left">{{salesPoint}}</pre>-->
    </section>
  </div>
</template>

<script>
import ServiceTipologyDD from "../components/dropdown/ServiceTipologyDD";
import SingleRegionDD from "../components/dropdown/SingleRegionDD";
import router from "../router.js";
import debounce from "lodash/debounce";

const sales_point_default = () => ({ id: 0, tipologyId: 0 });

export default {
  name: "sales-point-edit",
  components: { ServiceTipologyDD, SingleRegionDD },
  data() {
    return {
      salesPoint: sales_point_default(),
      similar_var_numbers: [],
      businessTypes: ['Bar','FastFood','FoodTruck','Gelateria','Hotel','Market','Piadineria','Pizzeria','Ristorante']
    };
  },
  methods: {
    typingVatNumber: debounce(function (input) {
      if (!input || input.length < 6) return;

      var vm = this;

      this.$ajax.request(
        {
          silent: true,
          address: `/salespoints/vat/${input}`,
          method: "GET",
          onSuccess: (response) => {
            vm.similar_var_numbers = response.data;
          },
        },
        true
      );
    }, 366),
    onDelete() {
      this.$buefy.dialog.confirm({
        title: "Cancella SalesPoint",
        message: `Sei sicuro di voler <b>cancellare</b> <i>${this.salesPoint.name}</i>? Verranno rimosse tutte le schede collegate. <b>Questa azione è irreversibile</b>.`,
        confirmText: "Elimina",
        cancelText: "Annulla",
        type: "is-danger",
        scroll: "keep",
        hasIcon: true,
        onConfirm: () => {
          this.$ajax.request({
            address: "/salespoints/" + this.salesPoint.id,
            method: "DELETE",
            onSuccess: () => {
              router.push({ name: "sales-points" });
            },
          });
        },
      });
    },
    formSubmit(e) {
      e.preventDefault();
      const vm = this;

      if (
        !this.salesPoint.id &&
        this.$ajax.getUserRole().id != 1 && // admin only TODO: make a permission
        this.similar_var_numbers.length != 0
      ) {
        this.$buefy.dialog.alert({
          title: "Attenzione",
          message:
            "Non puoi creare un elemento con <b>p.iva</b> duplicata. Contatta l'amministrazione",
          type: "is-warning",
          hasIcon: true,
          icon: "exclamation-triangle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true,
        });

        return;
      }

      if (this.salesPoint.id) {
        // update
        this.$ajax.request({
          address:
            "/salespoints/" + (this.$route.params.id || this.salesPoint.id),
          method: "PUT",
          data: this.salesPoint,
          onSuccess: (response) => {
            vm.salesPoint = response.data;
          },
        });
      } else {
        // new
        this.$ajax.request({
          address: "/salespoints/",
          method: "POST",
          data: this.salesPoint,
          onSuccess: (response) => {
            vm.salesPoint = response.data;
            router.go(-1);
            //router.push({ name: "user", params: { id: response.data.id } });
          },
        });
      }
    },
  },
  mounted() {
    this.salesPoint.tipologyId = this.$ajax.getUserRole().tipologyId;

    if (this.$route.params.id) {
      this.salesPoint.id = this.$route.params.id;

      const vm = this;
      this.$ajax.request({
        address: "/salespoints/" + this.$route.params.id,
        method: "GET",
        onSuccess: (response) => {
          vm.salesPoint = response.data;
        },
      });
    }
  },
};
</script>